<script setup lang="ts">

</script>

<template>
    <div class="dropdown-item-text">
        <slot />
    </div>
</template>